<script lang="ts">
	import type { ISbStoryData } from '@storyblok/js';
	import { editable } from '$lib/storyblok/editable';
	import Checkmark from '$lib/icons/checkmark.svelte';

	interface Props {
		content: ISbStoryData<{ text: string }>['content'];
	}

	let { content }: Props = $props();
</script>

<div use:editable={content} class="flex gap-x-2">
	<div
		class="mt-[3px] flex aspect-square h-[0.66lh] flex-shrink-0 items-center justify-center rounded-full border border-brown-1"
	>
		<Checkmark class="aspect-square h-[0.42lh]" />
	</div>
	<p class="text-[14px]/[160%] text-brown-1">{content.text}</p>
</div>
